export default __webpack_public_path__ + "static/media/logout.d329d929.svg";